var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.class == 'hrTag')?_c('hr'):(!_vm.delay)?_c('div',{class:this.class,style:(_vm.bubbleStyle)},[_vm._t("default")],2):_c('div',[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot_text"},[_c('div',{staticClass:"chat_loading"},[_c('span',{staticClass:"bg_clip"},[_vm._v("답변 준비중")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184be860","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/IcAnsBubble/IcAnsBubble.vue
// module id = 494
// module chunks = 0